<div class="my-account-container">
    <div class="my-account-container-title">{{ 'myAccount.title' | translate }}</div>
    <div class="grid lg:grid-cols-3 sm:grid-cols-1 gap-4">
        <div class="col-span-2">
            @if(loading) {
            <jjames-loading [text]="'myAccount.loading' | translate"></jjames-loading>
            }
            @else if(errorMessage) {
            <jjames-alert type="error" [title]="errorMessage"></jjames-alert>
            }
            @else {
            <app-general-account [accountData]="accountOperator" (editFormSubmitted)="onEditFormSubmitted($event)"></app-general-account>
            }
        </div>
    </div>
</div>